class FindOptionManager {
    constructor() {
        this._init()
    }
    _init() {
        this.els = document.querySelectorAll('[data-find-option]')
        if(this.els.length === 0) {
            return
        }
        this.els.forEach(el => el.findOption = new FindOption(el, this))
    }
}
class FindOption {
    constructor(el, manager) {
        this._init(el, manager)
    }
    _init(el, manager) {
        this.el = el 
        if(!this.el) {
            return
        }
        this.manager = manager
        this.select = this.el.getAttribute('value')
        this.selectChild(this.select)
    }
    selectChild(name) {
        for(let i = 0; i < this.el.children.length; i++) {
            let val = this.el.children[i].getAttribute('value')
            if(val === name) {
                this.el.selectedIndex = i
                this.el.dispatchEvent(new Event('change'))
                return
            }
        }
        this.el.selectedIndex = 0
        this.el.dispatchEvent(new Event('change'))
    }
}
export default FindOptionManager